import { createSelector } from 'reselect';
import {
  orderBy,
  partition,
  isEmpty,
  filter,
  find,
  get,
  sumBy,
  some,
} from 'lodash';
import { addLeadingZeros, isRoomOnline } from 'shared/helpers';

const getRoomMaterials = state => state.materialChain.roomMaterials;
const getTcEventMaterialTypes = state => state.materialChain.tcEventMaterialTypes;
const getRoomTypeMaterialTypes = state => state.materialChain.roomTypeMaterialTypes;
const getRoomMaterialsCount = state => state.materialChain.roomMaterialsCount;

const eventMaterials = state => state.materialChain.eventAllMaterials.testCenterEventMaterials;
const roomMaterials = state => state.materialChain.eventAllMaterials.roomMaterials;
const getTcEventRooms = state => state.tcEvent.rooms;

export const getGroupedMaterials = createSelector(
  [getRoomMaterials, getTcEventMaterialTypes],
  (roomMaterials, eventMaterialTypes) => {
    let materialGroups = [];
    if (eventMaterialTypes.length) {
      eventMaterialTypes.forEach((materialType) => {
        materialType.roomMaterials = roomMaterials.filter(material => material.materialTypeId === materialType.id);
        materialType.roomMaterials.map(range => {
          range.rangeBegin = addLeadingZeros(range.rangeBegin);
          range.rangeEnd = addLeadingZeros(range.rangeEnd);
        });
        materialGroups.push(materialType);
      });
    }
    return orderBy(materialGroups, 'id');
  }
);

export const mapRoomMaterials = createSelector(
  [roomMaterials],
  materials => {
    let result = [];
    materials && materials.map((material) => {
      if (!result[material.roomId]) {
        result[material.roomId] = [];
      }

      if (!result[material.roomId][material.materialTypeId]) {
        result[material.roomId][material.materialTypeId] = [];
      }

      result[material.roomId][material.materialTypeId].push(material);
    });
    return result;
  }
);

export const mapEventMaterials = createSelector(
  [eventMaterials],
  materials => {
    let result = [];
    materials && materials.map(material => {
      if (!result[material.materialTypeId]) {
        result[material.materialTypeId] = [];
      }

      result[material.materialTypeId].push(material);
    });

    return result;
  }
);

export const mapEventMaterialTypes = createSelector(
  [getTcEventMaterialTypes],
  eventMaterialTypes => {
    let result = [];
    eventMaterialTypes && eventMaterialTypes.map(type => {
      result[type.id] = type;
    });

    return result;
  }
);


export const calculateEventUsedMaterials = createSelector(
  [roomMaterials],
  materials => {
    let result = [];
    materials && materials.map(material => {
      if (!result[material.materialTypeId]) {
        result[material.materialTypeId] = 0;
      }
      result[material.materialTypeId] += material.count;
    });

    return result;
  }
);

export const mapRoomRanges = createSelector(
  [getRoomMaterials],
  ranges => {
    let result = [];
    ranges && ranges.map(range => {
      if (!result[range.materialTypeId]) {
        result[range.materialTypeId] = [];
      }

      result[range.materialTypeId].push(range);
    });

    return result;
  }
);

export const getRoomRanges = createSelector(
  [getRoomMaterials],
  ranges => {
    let result = [];
    ranges && ranges.map(range => {
      result.push(range);
    });

    return result;
  }
)

export const getAllMaterialTypesRoom = createSelector(
  [getTcEventMaterialTypes, getRoomTypeMaterialTypes, getRoomMaterials],
  (materialTypes, roomMaterialTypes, materials) => {
    let result = [];
    materialTypes.map(materialType => {
      if (some(roomMaterialTypes, {id: materialType.id}) || some(materials, {materialTypeId: materialType.id})) {
        result.push(materialType);
      }
    })
    return result;
  }
)

export const getRoomsSCStatus = createSelector(
  [getTcEventMaterialTypes, getRoomMaterialsCount, roomMaterials, getTcEventRooms],
  (materialTypes, roomMaterialsCount, roomMaterials, rooms) => {
    let result = [];

    roomMaterialsCount.map(roomInfo => {
      let materialsCount = filter(roomInfo.materials, material => material.total);
      let isSCStarted = some(roomInfo.materials, material => material.assigned);
      let room = find(rooms, {id: roomInfo.roomId});

      if (room && !isRoomOnline(room.roomType) &&
        materialsCount && materialsCount.length && roomMaterials && roomMaterials.length && isSCStarted) {
        result[roomInfo.roomId] = true;

        materialTypes.map(materialType => {
          let assignedMaterials = get(find(materialsCount, {materialTypeId: materialType.id}), 'assigned');
          let totalMaterials = get(find(materialsCount, {materialTypeId: materialType.id}), 'total');
          let usedMaterials = sumBy(filter(roomMaterials, {roomId : roomInfo.roomId, materialTypeId: materialType.id}), 'usedCount');
          if( totalMaterials && (!assignedMaterials || usedMaterials != assignedMaterials)) {
            result[roomInfo.roomId] = false;
          }
        });
      } else if (roomInfo.seatsInUse && room && isRoomOnline(room.roomType)) {
        result[roomInfo.roomId] =  room.examineeCount ? roomInfo.seatsInUse === room.examineeCount : null;
      }
      else {
        result[roomInfo.roomId] = null;
      }
    });

    return result;
  }
)
